module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/selling-small-7a15da7089515528160144e8e82964f4.svg";